import { atom } from 'jotai';

/**
 * eaiControlledDeviceIdsAtom
 * maintains the list of device IDs that are under EAI control
 */
export const eaiControlledDeviceIdsAtom = atom<string[] | undefined>(undefined);
eaiControlledDeviceIdsAtom.debugLabel = 'eaiControlledDeviceIdsAtom';
